import { IconMessageChatbot, IconPrinter, IconStar } from '@tabler/icons-react'
import { ReactNode } from 'react'
import { useShopBrand } from '@/contexts/shopBrandContext.tsx'

export default function QualityFooter() {
  const brand = useShopBrand()
  function FeatureLabel({ text, icon, description }: { text: string, icon: any, description: ReactNode }) {
    return <div className='flex flex-col md:flex-row gap-2 sm:justify-center items-center md:items-start mt-3 md:mt-5'>
      <div className='text-[1.5rem] flex justify-center items-center'>
        { icon }
      </div>
      <div className='text-center md:text-start mb-3 md:mb-5'>
        <h3 className='text-lg font-bold mb-2'>{ text }</h3>
        <p>
          { description }
        </p>
      </div>
    </div>
  }

  return <>
    <div className='bg-secondary mb-5 py-[2rem]'>
      <div className='container px-5 mx-auto grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-3'>
        <FeatureLabel text='4,9/5 Sterne auf Trustpilot' icon={<IconStar />}
                      description={<>Tausende Kunden vertrauen uns mit über 119 Bewertungen. Besuche uns auf <a
                        className='underline'
                        href="https://de.trustpilot.com/review/fridaysnap.de" target='_blank'
                        rel='noreferrer'>Trustpilot</a>.</>} />
        <FeatureLabel text='Made in Germany' icon='🇩🇪'
                      description='Wir drucken ausschließlich in Deutschland dank unseren erfahrenen Fotolabor-Partnern.' />
        <FeatureLabel text='Individuelle Fotoprodukte' icon={<IconPrinter />}
                      description={`Egal ob Fotoabzüge, Kalendar oder mehr, deine ${brand.name}-Galerie ist nahtlos integriert.`} />
        <FeatureLabel text='Persönlicher Support' icon={<IconMessageChatbot />}
                      description={<>Als deutsches Team sind wir stets über<a className='underline'
                                                                              href='https://wa.me/496987000170'
                                                                              target='_blank'>WhatsApp</a> und <a
                        className='underline' href='mailto:hello@fridaysnap.de'
                        target='_blank'>hello@fridaysnap.de</a> erreichbar.</>} />
      </div>
    </div>
  </>
}
